import { ExternalLink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ContentCategory } from '@/types';
import { getUnlockedCategoryPath } from '@/utils/contentRoutes';

interface Props {
  item: ContentCategory;
}

export default function Card({ item }: Props) {
  const navigate = useNavigate();

  const goToDetails = () => {
    navigate(getUnlockedCategoryPath(item.id));
  };
  return (
    <div
      onClick={goToDetails}
      className="bg-white rounded-xl shadow-[0_2px_11px_rgba(12,0,22,0.2)] 
      border-l-4 border-darkPurple p-4 flex flex-col justify-between 
      hover:shadow-lg cursor-pointer font-noto"
    >
      <div className="flex justify-between items-center">
        <img
          src={item.iconUrl}
          alt={`${item.title} icon`}
          className="w-[72px] h-[72px] object-cover"
        />

        <button onClick={goToDetails} className="p-2 rounded-md text-darkPurple">
          <ExternalLink size={28} />
        </button>
      </div>

      <div className="mt-4">
        <h3 className="text-lg font-semibold text-darkPurple">{item.title}</h3>
        <p className="text-sm text-gray-500 mt-1 line-clamp-2">
          {item.description || 'No description available'}
        </p>
      </div>
      <div className="border-t my-3" />

      <div className="flex justify-between text-sm text-gray-600">
        <div className="flex flex-col items-center">
          <p className="text-[#62556B] text-[16px]">Total Track:</p>
          <p className="text-darkPurple text-xl font-bold">{item.contentCount}</p>
        </div>
        {/* <div className="flex flex-col items-center">
          <p className="text-[#62556B] text-[16px]">Total Plays:</p>
          <p className="text-darkPurple text-xl font-bold">{item.totalPlays}</p>
        </div> */}
      </div>
    </div>
  );
}
